/** @module store/amperix_commission_infos */
import { getAmperixCommissionInfoByEms } from '@/api/amperix_commission_infos'

/**
 * The state is a mapping from serialno to AmperixCommissionInfo
 */
const state = () => ({})

const mutations = {
  SET_COMMISSION_INFO: (state, { commissionInfo }) => {
    if (commissionInfo && commissionInfo.serialno) {
      state[commissionInfo.serialno] = commissionInfo
    }
  }
}

const getters = {
  getCommissionInfo: (state) => {
    return (serialno) => {
      if (serialno && state[serialno]) {
        return state[serialno]
      }
      return {}
    }
  }
}

const actions = {
  getCommissionInfo({ commit }, { ctxt, emsId = null }) {
    if (!emsId) return

    return getAmperixCommissionInfoByEms({ ctxt, emsId }).then((rsp) => {
      const data = rsp.payload.data?.attributes

      if (!data) return null

      const commissionInfo = new AmperixCommissionInfo({
        id: data.id,
        billingExpirationDate: data.billingExpirationDate,
        status: data.status,
        commissioningDate: data.commissioningDate,
        licenseType: data.licenseType,
        licenseIssuerId: data.licenseIssuerId,
        licenseId: data.licenseId,
        serialno: data.serialno
      })

      commit('SET_COMMISSION_INFO', { commissionInfo })
      return data.serialno
    })
  }
}

/**
 * A AmperixCommissionInfo data-struct.
 *
 * @constructor
 *
 * @param {object} params
 * @param {string|integer} params.id is the groups's ID
 * @param {string} params.billingExpirationDate
 * @param {string} params.status
 * @param {string} params.commissioningDate
 * @param {string} params.licenseType
 * @param {string} params.licenseIssuerId
 * @param {string} params.licenseId
 * @param {string} params.serialno
 *
 */
export function AmperixCommissionInfo({
  id,
  billingExpirationDate,
  status,
  commissioningDate,
  licenseType,
  licenseIssuerId,
  licenseId,
  serialno
}) {
  if (!serialno) {
    throw TypeError('Missing or invalid name.')
  }

  this.id = parseInt(id)
  this.billingExpirationDate = billingExpirationDate
  this.status = status
  this.commissioningDate = commissioningDate
  this.licenseType = licenseType
  this.licenseIssuerId = licenseIssuerId
  this.licenseId = licenseId
  this.serialno = serialno
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
